import { GetAdminEmailTemplatesRequest, GetAdminEmailTemplatesResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminEmailTemplatesService {
    public async getEmailTemplates(request: GetAdminEmailTemplatesRequest): Promise<GetAdminEmailTemplatesResult> {
        return api.admin.getEmailTemplates(request);
    }
}

export const service = new AdminEmailTemplatesService();